<script setup lang="ts">
const to = useSerpLinkFromCriteria({
  transactionType: 'sale',
  projectTypes: ['used'],
});
</script>

<template>
  <IadStickySmallDevice>
    <IadBtn
      class="w-full"
      size="large"
      :text="$t(`core.common.find_property`)"
      :to
      @click="trackEvent({
        event: 'navigation',
        event_name: 'cta_click',
        cta_type: 'property',
        cta_name: 'find_property',
      })"
    />
  </IadStickySmallDevice>
</template>
